import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export const TaskRewardStatusType = {
  NEW        : null,
  PENDING    : 0,
  ACCEPTED   : 1,
  REJECTED   : 2
};

export const TaskType = {
  TEXT         : 0,
  PICTURE      : 1,
  TEXT_PICTURE : 2
};

export const TextInputType = {
  TEXT  : 0,
  LINK  : 1,
};

export default class Task {

  static endpoints = {
    index: `${baseUrl}/tasks`,
  };

  static get defaultValue() {
    return {
      input: "",
      file : null
    }
  }

  static getTaskStatusBySubmits(task) {
    let acceptedSubmits = Number(task.acceptedSubmits) || 0;
    let rejectedSubmits = Number(task.rejectedSubmits) || 0;
    let submits         = Number(task.submits) || 0;
     
    if(rejectedSubmits > 0) return TaskRewardStatusType.REJECTED;
    if(task.allowedSubmits === submits && task.allowedSubmits === acceptedSubmits) return TaskRewardStatusType.ACCEPTED;
    if(task.allowedSubmits === submits) return TaskRewardStatusType.PENDING;
   
    return TaskRewardStatusType.NEW;
  };

  static paginators = {
    available : (data)=> axios.get(`${this.endpoints.index}/available` , {params: data}).then((response)=> response.data.available.items),
    claimed   : (data)=> axios.get(`${this.endpoints.index}/claimed`   , {params: data}).then((response)=> response.data.claimed.items),
  };


  static submit(id, payload) {
    let headers = {'content-type': 'multipart/form-data'};
    return axios.post(`${this.endpoints.index}/${id}/submit`, payload, headers).then((response)=> response.data.tasks);
  };
}

